import * as React from 'react';
import { confirmSignOut } from '../../actions/authActions';
import { showProfile, hideProfile } from '../../actions/profileActions';
import { Link } from 'react-router-dom';
import { showReferFriend, showInEditScreen, showContinueOnPhone } from '../../actions/modalActions';
import { connect } from 'react-redux';
import { slide as Menu } from "react-burger-menu";
import { REQUEST_DOCUMENTS, DONATE_MY_DECREASE, CONTACT_US, MY_QUOTE, PERSONAL_DETAILS, PERSONAL_INSURANCE, REFER_A_FRIEND, LIFE_INSURANCE, BASE_START_PROCESS, FNOL_SUBMIT_CLAIM, CLAIM_HISTORY_V2, GET_LIFE_INSURANCE, CHOOSE_PERSONAL_DETAILS } from '../../routes/routes';
import { Image, Form } from 'react-bootstrap';
import './BurgerMenu.css';
import { navigateTo } from '../../actions/navigationActions';
import { NAVIGATE_HOME } from '../../constants/constants';
import { clearSelectedDamages, resetFNOL, resetSelectedFNOLItems, setStep } from '../../actions/claimSubmitActions';
let referAFriendClearTimer = setTimeout(() => { }, 0);


class BurgerMenu extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            menuOpen: false,
            resetMenuSelected: false
        };
        this.handleSignOut = this.handleSignOut.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCloseMenu = this.handleCloseMenu.bind(this);
        this.startReferAFriendClearTimer = this.startReferAFriendClearTimer.bind(this);
    }

    handleSignOut(e: any) {
        this.handleCloseMenu(e);
        this.props.confirmSignOut();
    }


    async startReferAFriendClearTimer() {
        clearTimeout(referAFriendClearTimer);
        referAFriendClearTimer = setTimeout(
            () => {
                this.setState({ menuSelectedReferAFriend: false });
            }, 4000);
    }

    async handleRedirect(destination) {
        this.setState({ resetMenuSelected: false });

        if (!this.props.profile.isLinked && (
            destination === PERSONAL_DETAILS ||
            destination === PERSONAL_INSURANCE ||
            destination === REQUEST_DOCUMENTS ||
            destination === DONATE_MY_DECREASE ||
            destination === REFER_A_FRIEND ||
            destination === MY_QUOTE ||
            destination === LIFE_INSURANCE ||
            destination === FNOL_SUBMIT_CLAIM ||
            destination === CLAIM_HISTORY_V2)
        ) {
            // do nothing
            if ((this.props.ssp.livinEnabled && this.props.profile.isLifeLinked) && (destination === LIFE_INSURANCE || destination === PERSONAL_DETAILS || destination === REQUEST_DOCUMENTS)) {
                this.props.redirectTo(destination);
            }
        }
        else {

            if (destination === NAVIGATE_HOME && !this.props.sales.isInEdit) {
                this.setState({ resetMenuSelected: true });
            }
            else if (destination === REFER_A_FRIEND && !this.props.sales.isInEdit || destination === REFER_A_FRIEND) {
                this.props.dispatchShowReferFriend();
                this.setState({ menuSelectedReferAFriend: "burgermenu-active-link" });
                this.setState({ resetMenuSelected: true });
                this.startReferAFriendClearTimer();
            }

            else if (destination === LIFE_INSURANCE) {
                if (this.props.profile.isLifeLinked) {
                    this.props.redirectTo(destination);
                } else {
                    destination = GET_LIFE_INSURANCE;
                    this.props.redirectTo(GET_LIFE_INSURANCE);
                }
            }
            else if (destination === PERSONAL_DETAILS) {
                if (this.props.ssp.livinEnabled && this.props.profile.isLifeLinked) {
                    this.props.redirectTo(CHOOSE_PERSONAL_DETAILS);
                } else {
                    this.props.redirectTo(destination);
                }
            }

            else if (destination === FNOL_SUBMIT_CLAIM) {
                await this.props.dispatchResetFNOL();
                await this.props.dispatchClearSelectedDamages();
                await this.props.dispatchSetStep(1, 1)
                this.props.redirectTo(destination);
            }
            else if (destination === LIFE_INSURANCE) {
                if (this.props.profile.isLifeLinked) {
                    this.props.redirectTo(destination);
                } else {
                    destination = GET_LIFE_INSURANCE;
                    this.props.redirectTo(GET_LIFE_INSURANCE);
                }
            }
            else if (destination === PERSONAL_DETAILS) {
                if (this.props.ssp.livinEnabled && this.props.profile.isLifeLinked) {
                    this.props.redirectTo(CHOOSE_PERSONAL_DETAILS);
                } else {
                    this.props.redirectTo(destination);
                }
            }
            else if (destination !== REFER_A_FRIEND) {
                this.setState({ menuSelectedReferAFriend: false });
                this.props.redirectTo(destination);
            }
        }

        this.handleCloseMenu(destination);
    }

    handleCloseMenu(e: any) {
        this.setState({ menuOpen: false })
    }

    handleStateChange(state) {
        this.setState({ menuOpen: state.isOpen })
    }

    public render() {
        /// Conditional Render Control of Menu Items & Animation effect ///
        this.setState({
            burgerMenuDesktopAnimationTrueFalse: true,
            showLifeInsurance: this.props.ssp.livinEnabled && this.props.profile.countryId === 244,
            showMyQuote: false,
            showSubmitAClaim: true,
            showClaimsHistory: true
        });
        let activeLinkClassState = "burgermenu-active-link burgermenu-active-link-not-" + this.state.resetMenuSelected;
        let userImage = "./images/BurgerMenu/user-24-px-active.svg";
        let folderImage = "./images/BurgerMenu/folder-24-px-active.svg";
        let claimsProgressImage = "./images/BurgerMenu/claims-progress-24-px-active.svg";
        let donateImage = "./images/BurgerMenu/donate-24-px-active.svg";
        let referImage = "./images/BurgerMenu/refer-a-friend-24-px-active.svg";
        let quoteImage = "./images/BurgerMenu/shopping-cart-24-px-active.svg";
        let contactUsImage = "./images/BurgerMenu/contact-us-24-px-active.svg";
        let signOutImage = "./images/BurgerMenu/sign-out-24-px-active.svg";
        let shieldImage = "./images/BurgerMenu/icons-line-style-shield-white-24-px.svg";
        let heartImage = "./images/BurgerMenu/icons-line-style-heart-inactive-white-24-px.svg";
        let styleTemplate = "./images/BurgerMenu/icons-line-style-shield-white-24-px.svg";
        let menuTsCs =
            <>
                {this.props.profile.countryId === 244 &&
                    <div className="ssp-new-menu-footer-container">
                        <div className="new-kp-fsp">
                            Our&nbsp;
                        <a className="ssp-footer-link" href="https://www.kingprice.co.za/terms-and-conditions/" target="_blank">T's and C's</a>
                        &nbsp;and&nbsp;
                        <a className="ssp-footer-link" href="https://www.kingprice.co.za/privacy-policy/" target="_blank">POPIA policy</a>
                        </div>
                    </div>
                }
                {this.props.profile.countryId === 157 &&
                    <div className="ssp-new-menu-footer-container">
                        <div className="new-kp-fsp">
                            Our&nbsp;
                        <a className="ssp-footer-link" href="https://www.kingprice.co.na/Home/terms-and-conditions/" target="_blank">T's and C's</a>
                        </div>
                    </div>
                }
            </>
        return (
            <>
                <div className="ssp-preload">
                    <img src="./images/BurgerMenu/user-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/folder-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/claims-progress-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/donate-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/refer-a-friend-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/shopping-cart-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/contact-us-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/sign-out-24-px-active.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/icons-line-style-shield-white-24-px.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/icons-line-style-heart-inactive-white-24-px.svg" alt="" title="" />
                    <img src="./images/BurgerMenu/user-24-px-inactive.svg" alt="" title="" />
                </div>
                <div className="d-none d-lg-block d-md-none">
                    <div className={"burger-menu ssp-burger-menu-desktop ssp-desktop-menu-animation-" + this.state.burgerMenuDesktopAnimationTrueFalse + " ssp-desktop-menu-profile-linked-" + this.props.profile.isLinked}>
                        <Link className={this.props.navigation.menuSelected.personalInsurance ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(PERSONAL_INSURANCE)} >
                            <div className="burger-menu-link">
                                <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={shieldImage} alt={""} title={""} />
                                <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Personal policy</Form.Label>
                            </div>
                        </Link>

                        {
                            (this.state.showLifeInsurance === true) &&
                            <>
                                <Link className={this.props.navigation.menuSelected.lifeInsurance ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(LIFE_INSURANCE)} >
                                    <div className="burger-menu-link">
                                        <Image className={this.props.profile.isLifeLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={heartImage} alt={""} title={""} />
                                        <Form.Label className={this.props.profile.isLifeLinked ? "" : " isGuest"}>Livin' policy</Form.Label>
                                    </div>
                                </Link>
                            </>
                        }

                        <hr className="burger-menu-line" />

                        <Link className={this.props.navigation.menuSelected.personalDetails ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(PERSONAL_DETAILS)} >
                            <div className="burger-menu-link ">
                                <Image className={this.props.profile.isLinked || this.props.profile.isLifeLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={userImage} alt={""} title={""} />
                                <Form.Label className={this.props.profile.isLinked || this.props.profile.isLifeLinked ? "" : " isGuest"}>My details</Form.Label>
                            </div>
                        </Link>

                        <Link className={this.props.navigation.menuSelected.requestDocuments ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(REQUEST_DOCUMENTS)}>
                            <div className="burger-menu-link ">
                                <Image className={this.props.profile.isLinked || this.props.profile.isLifeLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={folderImage} alt={""} title={""} />
                                <Form.Label className={this.props.profile.isLinked || this.props.profile.isLifeLinked ? "" : " isGuest"}>Request a document</Form.Label>
                            </div>
                        </Link>

                        {
                            (this.state.showSubmitAClaim === true) &&
                            <>
                                <Link className={this.props.navigation.menuSelected.submitClaim ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(FNOL_SUBMIT_CLAIM)} >
                                    <div className="burger-menu-link">
                                        <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={claimsProgressImage} alt={""} title={""} />
                                        <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Submit a claim</Form.Label>
                                    </div>
                                </Link>
                            </>
                        }

                        {
                            (this.state.showClaimsHistory === true) &&
                            <>
                                <Link className={this.props.navigation.menuSelected.claimsHistoryV2 ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(CLAIM_HISTORY_V2)} >
                                    <div className="burger-menu-link">
                                        <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={claimsProgressImage} alt={""} title={""} />
                                        <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Claims progress</Form.Label>
                                    </div>
                                </Link>
                            </>
                        }

                        <Link className={this.state.menuSelectedReferAFriend ? "burgermenu-active-link" : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to='/#' onClick={() => this.handleRedirect(REFER_A_FRIEND)}>
                            <div className="burger-menu-link" >
                                <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={referImage} alt={""} title={""} />
                                <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Refer a friend</Form.Label>
                            </div>
                        </Link>
                        {
                            (this.state.showMyQuote === true) &&
                            <>
                                <Link className={this.props.navigation.menuSelected.myQuote ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(MY_QUOTE)}>
                                    <div className="burger-menu-link">
                                        <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={quoteImage} alt={""} title={""} />
                                        <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>My quote</Form.Label>
                                    </div>
                                </Link>
                            </>
                        }

                        <Link to="/#" className={this.props.navigation.menuSelected.contactUs ? activeLinkClassState : ""} onClick={() => this.handleRedirect(CONTACT_US)}>
                            <div className="ssp-desktop-burgermenu-contactus burger-menu-link">
                                <Image className="burger-menu-image" src={contactUsImage} alt={""} title={""} />
                                <Form.Label className="cursor-pointer">Contact us</Form.Label>
                            </div>
                        </Link>

                        {/*Style Template*/}
                        {(this.props.profile.email?.toLowerCase() ?? "") === "happystylinguser@kingprice.dev" &&
                            <Link to="/#" onClick={() => this.handleRedirect(BASE_START_PROCESS)}>
                                <div className="burger-menu-link">
                                    <Image className="burger-menu-image" src={styleTemplate} alt={""} title={""} />
                                    <Form.Label className="cursor-pointer">SSP Styling Foundation</Form.Label>
                                </div>
                            </Link>
                        }

                        <Link to="/#" onClick={this.handleSignOut}>
                            <div className="ssp-desktop-burgermenu-logout burger-menu-link" onClick={this.handleSignOut}>
                                <Image className="burger-menu-image" src={signOutImage} alt={""} title={""} />
                                <Form.Label className="cursor-pointer">Log out</Form.Label>
                            </div>
                        </Link>

                        {menuTsCs}
                    </div>
                </div>

                {/*/// New Mobile Menu ///*/}
                <div id="mobileBurgerMenu" className={"d-block d-lg-none d-md-block " + "ssp-burger-menu-state-" + this.state.menuOpen}>
                    <Menu
                        pageWrapId="mobileBurgerMenu"
                        outerContainerId="App"
                        isOpen={this.state.menuOpen}
                        onStateChange={(state) => this.handleStateChange(state)}
                    >
                        <div className={"burger-menu bm-mobile ssp-burger-menu-new-mobile ssp-desktop-menu-animation-" + this.state.burgerMenuDesktopAnimationTrueFalse + " ssp-desktop-menu-profile-linked-" + this.props.profile.isLinked}>
                            <Link className={this.props.navigation.menuSelected.personalInsurance ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(PERSONAL_INSURANCE)} >
                                <div className="burger-menu-link">
                                    <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={shieldImage} alt={""} title={""} />
                                    <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Personal policy</Form.Label>
                                </div>
                            </Link>

                            {
                                (this.state.showLifeInsurance === true) &&
                                <>
                                    <Link className={this.props.navigation.menuSelected.lifeInsurance ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(LIFE_INSURANCE)} >
                                        <div className="burger-menu-link">
                                            <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={heartImage} alt={""} title={""} />
                                            <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Life insurance</Form.Label>
                                        </div>
                                    </Link>
                                </>
                            }

                            <hr className="burger-menu-line" />

                            <Link className={this.props.navigation.menuSelected.personalDetails ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(PERSONAL_DETAILS)} >
                                <div className="burger-menu-link ">
                                    <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={userImage} alt={""} title={""} />
                                    <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>My details</Form.Label>
                                </div>
                            </Link>

                            <Link className={this.props.navigation.menuSelected.requestDocuments ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(REQUEST_DOCUMENTS)}>
                                <div className="burger-menu-link ">
                                    <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={folderImage} alt={""} title={""} />
                                    <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Request a document</Form.Label>
                                </div>
                            </Link>

                            {
                                (this.state.showSubmitAClaim === true) &&
                                <>
                                    <Link className={this.props.navigation.menuSelected.submitClaim ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(FNOL_SUBMIT_CLAIM)} >
                                        <div className="burger-menu-link">
                                            <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={claimsProgressImage} alt={""} title={""} />
                                            <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Submit a claim</Form.Label>
                                        </div>
                                    </Link>
                                </>
                            }

                            {
                                (this.state.showClaimsHistory === true) &&
                                <>
                                    <Link className={this.props.navigation.menuSelected.claimsHistoryV2 ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(CLAIM_HISTORY_V2)} >
                                        <div className="burger-menu-link">
                                            <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={claimsProgressImage} alt={""} title={""} />
                                            <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Claims progress</Form.Label>
                                        </div>
                                    </Link>
                                </>
                            }

                            <Link className={this.state.menuSelectedReferAFriend ? "burgermenu-active-link" : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to='/#' onClick={() => this.handleRedirect(REFER_A_FRIEND)}>
                                <div className="burger-menu-link" >
                                    <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={referImage} alt={""} title={""} />
                                    <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>Refer a friend</Form.Label>
                                </div>
                            </Link>
                            {
                                (this.state.showMyQuote === true) &&
                                <>
                                    <Link className={this.props.navigation.menuSelected.myQuote ? activeLinkClassState : "" + " " + this.props.profile.isLinked ? "cursor-pointer" : "cursor-default"} to="/#" onClick={() => this.handleRedirect(MY_QUOTE)}>
                                        <div className="burger-menu-link">
                                            <Image className={this.props.profile.isLinked ? "burger-menu-image " : "burger-menu-image isGuest"} src={quoteImage} alt={""} title={""} />
                                            <Form.Label className={this.props.profile.isLinked ? "" : " isGuest"}>My quote</Form.Label>
                                        </div>
                                    </Link>
                                </>
                            }

                            <Link to="/#" className={this.props.navigation.menuSelected.contactUs ? activeLinkClassState : ""} onClick={() => this.handleRedirect(CONTACT_US)}>
                                <div className="ssp-desktop-burgermenu-contactus burger-menu-link">
                                    <Image className="burger-menu-image" src={contactUsImage} alt={""} title={""} />
                                    <Form.Label className="cursor-pointer">Contact us</Form.Label>
                                </div>
                            </Link>

                            {/*Style Template*/}
                            {this.props.profile.email === "happyStylingUser@kingprice.dev" &&
                                <Link to="/#" onClick={() => this.handleRedirect(BASE_START_PROCESS)}>
                                    <div className="burger-menu-link">
                                        <Image className="burger-menu-image" src={styleTemplate} alt={""} title={""} />
                                        <Form.Label className="cursor-pointer">Base template</Form.Label>
                                    </div>
                                </Link>
                            }

                            <Link to="/#" onClick={this.handleSignOut}>
                                <div className="ssp-desktop-burgermenu-logout burger-menu-link" onClick={this.handleSignOut}>
                                    <Image className="burger-menu-image" src={signOutImage} alt={""} title={""} />
                                    <Form.Label className="cursor-pointer">Log out</Form.Label>
                                </div>
                            </Link>
                            <div className="ssp-burger-menu-mobile-spacer">
                                &nbsp;
                            </div>
                            {menuTsCs}
                        </div>
                    </Menu>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile,
        ssp: state.ssp,
        router: state.router,
        lifePolicy: state.lifePolicy,
        sales: state.sales,
        navigation: state.navigation
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        confirmSignOut: () => dispatch(confirmSignOut()),
        hideProfile: () => dispatch(hideProfile()),
        showProfile: () => dispatch(showProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowReferFriend: () => dispatch(showReferFriend()),
        showInEditScreen: (id, destination) => dispatch(showInEditScreen(id, destination)),
        dispatchShowContinueOnPhone: () => dispatch(showContinueOnPhone()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchClearSelectedDamages: () => dispatch(clearSelectedDamages()),
        dispatchResetFNOL: () => dispatch(resetFNOL()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BurgerMenu)